export const APP_NAME = 'Recepcionar Gestión Caso'

export const DEFAULT_PAGE_SIZE = 10

// HTTP methods
export const POST = 'POST'
export const PUT = 'PUT'
export const DELETE = 'DELETE'

// API Routes
export const URL_API =
  'https://i71xu8cd55.execute-api.us-west-1.amazonaws.com/desa/api'
export const API_GESTION_CASES = '/caso'
export const API_GESTION_CASES_RECEIVE = '/detalles'
export const API_FORM_LABEL = '/cfg-forms'
export const API_GETION_CASES_IMPLICATED = '/caso/implicado/terceros'
export const API_GETION_CASES_DOCUMENTS = '/caso/documentos'
export const URL_GETION_CASES = 'recepcionCasos'
export const API_GETION_CASES_IMPLICATED_DETAIL = '/caso/implicado'
export const API_GETION_CASES_COMUNES = '/generales'
export const API_GETION_CASES_COMPANY = '/companias'
export const API_GETION_CASES_BRAND = '/marcas'
export const API_GETION_CASES_POST_BITACORAS = '/caso/recepcionar'

export const API_ASSIGNATED_INSURED = '/proveedores-rol'
export const API_ASSIGNATED_PRE_RESPONSIBLE = '/responsables/consolidado-resp'
export const API_ASSIGNATED_ZONES_RESPONSABLE = '/responsables/xzona'
export const API_ASSIGNATED_RESPONSIBLE = '/caso/asigna-responsable'

export const API_RECORD_LIQUIDATION_COIN = '/monedas'
export const API_RECORD_LIQUIDATION = '/caso/liquidacion'
